import { Dispatch, SetStateAction, useState } from 'react'
import AddIcon from '@material-ui/icons/Add'
import { Box, Select, MenuItem, Typography } from '@material-ui/core'
import { Button } from '@resiliatech/birdsong'
import { useAppState } from 'Context/AppContext/AppContext'
import { Dimension } from 'Generated/graphql-types'
import { analytics } from 'Modules/Analytics'
import { initiatives } from 'Modules/Analytics/trackActionInterface/Impact/Initiatives'
import { DimensionInput } from 'TypeDefs/Objectives'
import { MAX_DIMENSIONS } from 'TypeDefs/Categories'
import {
  Container,
  CreateButton,
  CreateTitle,
} from './DimensionSelector.styles'

type DimensionSelectorProps = {
  allDimensions: Dimension[]
  dimensionInfo: DimensionInput[]
  setDimensionInfo: Dispatch<SetStateAction<DimensionInput[]>>
}

const DimensionSelector = ({
  allDimensions,
  dimensionInfo,
  setDimensionInfo,
}: DimensionSelectorProps) => {
  const {
    nonprofitOrgConfig: { role, nonprofitOrgRole },
  } = useAppState()
  const [showSelector, setShowSelector] = useState<boolean>(false)

  const handleAddCategory = () => {
    selectDimension(null)
    analytics.trackActionCreator(initiatives.Add_Category_Clicked)({
      role,
      relationship: nonprofitOrgRole,
    })
  }

  const selectDimension = (selected: DimensionInput | null) => {
    const selectedDimension =
      allDimensions.find((item) => item.id === selected?.id) ||
      ({ title: '' } as Dimension)
    const { id, title } = selectedDimension
    if (selectedDimension) {
      setDimensionInfo((currentDimensionInfo) => [
        ...currentDimensionInfo,
        { id, title },
      ])
    }
  }
  return (
    <Container>
      <Button
        variant='secondary'
        leadingIcon={<AddIcon />}
        label='Add Category'
        onClick={handleAddCategory}
        isDisabled={dimensionInfo.length === MAX_DIMENSIONS}
      />
      {showSelector && (
        <Select
          disableUnderline
          IconComponent={() => null}
          open={showSelector}
          value=''
          onClose={() => setShowSelector(false)}
        >
          {allDimensions.length ? (
            allDimensions.map(({ id, title }) => (
              <MenuItem
                key={id}
                value={title}
                onClick={() => selectDimension({ id, title })}
              >
                {title}
              </MenuItem>
            ))
          ) : (
            <MenuItem value='no-dimensions' key='no-dimensions' disabled>
              <Box>
                <Typography>No existing dimensions</Typography>
              </Box>
            </MenuItem>
          )}
          <MenuItem
            value='add-new-dimension'
            key='add-new-dimension'
            onClick={() => selectDimension(null)}
          >
            <CreateButton>
              <AddIcon />
              <CreateTitle>Create Category</CreateTitle>
            </CreateButton>
          </MenuItem>
        </Select>
      )}
    </Container>
  )
}

export default DimensionSelector
